// Node.js port of csharp Assembler.Timing.TimingStage / lean4 Assembler.Base.Timing.TimingStage.
// The stages a PhaseTiming scope brackets: building a loader, merging a request, a harness step and
// one web request.
export enum TimingStage {
    Load,
    Merge,
    Harness,
    Request
}
